import React, { MouseEvent } from 'react'
import { IIntegrationHash, IIntegration } from '@api/integration/types'
import { H4, Card, Intent } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Flex, Button } from '@ui'
import { Classes } from '@blueprintjs/core'
import { useAppData } from '@providers'
import css from './availableSection.module.scss'

export default function Integrations({
  available,
  activeSection,
  setAvailableIntegration,
  loading = false,
}: {
  available: IIntegrationHash
  activeSection: string
  setAvailableIntegration: (integration: IIntegration | null) => void
  loading?: boolean
}) {
  const product = useAppData().product

  return (
    <div>
      {!loading && (
        <div
          style={{
            fontSize: 18,
            fontWeight: 'bold',
            marginLeft: 10,
          }}
        >
          Available
        </div>
      )}
      {activeSection === 'All' ? (
        Object.keys(available).map((key) => (
          <div key={key} style={{ marginBottom: 40 }}>
            <div className={css.category_name}>
              <span className={loading ? Classes.SKELETON : undefined}>{key}</span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {available[key].map((integration) => {
                const enabled = product.integrations.includes(integration.source)
                return (
                  <AvailableCard
                    loading={loading}
                    key={integration.id}
                    enabled={enabled}
                    integration={integration}
                    onClick={() => enabled && setAvailableIntegration(integration)}
                  />
                )
              })}
            </div>
          </div>
        ))
      ) : (
        <div>
          <div className={css.category_name}>
            <span className={loading ? Classes.SKELETON : undefined}>{activeSection}</span>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {available[activeSection].map((integration) => {
              const enabled = product.integrations.includes(integration.source)
              return (
                <AvailableCard
                  loading={loading}
                  key={integration.id}
                  enabled={enabled}
                  integration={integration}
                  onClick={() => enabled && setAvailableIntegration(integration)}
                />
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

const AvailableCard = ({
  enabled,
  integration,
  onClick,
  loading,
}: {
  enabled: boolean
  integration: IIntegration
  onClick: (e: MouseEvent<HTMLDivElement | HTMLElement>) => void
  loading: boolean
}) => {
  return (
    <Tooltip2
      disabled={enabled}
      content="Integration not available. Contact Customer Success to upgrade"
      targetProps={{ style: { width: '100%' } }}
    >
      <div className={css.card_wrapper}>
        <Card
          style={{
            height: 244,
            width: 278,
            cursor: 'pointer',
            position: 'relative',
            opacity: enabled ? 1 : 0.7,
          }}
          onClick={onClick}
        >
          <Flex align="center" style={{ height: 70 }}>
            <img
              className={loading ? Classes.SKELETON : undefined}
              width="55"
              height="auto"
              alt="integration"
              src={integration.image}
            />
          </Flex>
          <H4 className={loading ? Classes.SKELETON : undefined}>{integration.name}</H4>
          <div
            className={loading ? Classes.SKELETON : undefined}
            style={{ color: 'var(--grey1)', fontSize: 14, marginTop: 10 }}
          >
            {integration.description}
          </div>
          <Button
            className={loading ? Classes.SKELETON : undefined}
            intent={Intent.PRIMARY}
            text="Activate"
            style={{ position: 'absolute', left: 20, bottom: 20 }}
            onClick={onClick}
          />
        </Card>
      </div>
    </Tooltip2>
  )
}
